import { Controller } from '@hotwired/stimulus'
import { post, put } from '@rails/request.js'

export default class extends Controller {
  static targets = ['selectedActivityDataInput', 'searchForm']

  connect() {
    const isPerimeterFormHidden = this.element.parentNode.classList.contains('hidden')

    if (isPerimeterFormHidden) {
      this.updateReductionTargetCounter()
    }

    this.searchFormTarget.addEventListener('submit', event => {
      event.preventDefault()
      const form = this.searchFormTarget
      const url = form.getAttribute('action')
      const formData = new FormData(form)

      put(url, { responseKind: 'turbo-stream', body: formData })
    })
  }

  initTable() {
    const form = this.searchFormTarget
    const updateTableUrl = form.action
    const formData = new FormData(form)

    put(updateTableUrl, { responseKind: 'turbo-stream', body: formData })
  }

  updateReductionTargetCounter() {
    const counterFrame = document.querySelector('turbo-frame#reduction-target-counter')
    if (counterFrame) {
      const updateReductionTargetCounterUrl = counterFrame.dataset.updateReductionTargetCounterUrl
      const activityDataIds = this.selectedActivityDataInputTarget.value
      const reportIdInput = document.querySelector("input[name='report_id']")
      const reportId = reportIdInput.value

      const data = { activity_data_ids: activityDataIds, report_id: reportId }

      post(updateReductionTargetCounterUrl, {
        responseKind: 'turbo-stream',
        body: JSON.stringify(data)
      })
    }
  }

  // private

  emptyActivityDataSelection() {
    this.selectedActivityDataInputTarget.value = ''
  }
}
